const List = ({ label, children }) => (
    <tr>
        <td style={{fontSize: 14}}>{label}</td>
        <td className="px-2" style={{fontSize: 14}}>:</td>
        <td style={{fontSize: 14}}>{children}</td>
    </tr>
)

export default List